// ----------------------------------------------------------------------
// <copyright file="Izenda.TableColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;

  var TableColumn = React.createClass({
    propTypes : {
      width : PropTypes.number,
      minWidth: PropTypes.number,
      fixed : PropTypes.bool,
      resizable: PropTypes.bool
    },
    getDefaultProps : function () {
      return {
        width : 100,
        minWidth : 100,
        fixed: false,
        resizable: true
      }
    },
    render: function () {
      return <span {...this.props} />;
    }
  });

  module.exports = TableColumn;
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.TableColumn.jsx